import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT} from "@containers/singleVoyage/views/constants/theme";

export const sx:SxType = {
    btn:{
        fontWeight:'600',
        position:'absolute',
        right:'15px',
        top:'15px',
        zIndex:5555,
        // the secondary tint alone is 12% opaque and the map shows through it, so on the map the
        // same tint is pre-mixed with the surface colour and kept at 90%
        '&.secondary, &.secondary:hover': {
            boxShadow: SV_LIGHT.shadowSm,
            '.lightTheme &': {
                backgroundColor: 'rgba(234, 241, 250, 0.9)',
                color: SV_LIGHT.accent,
            },
            '.darkTheme &': {
                backgroundColor: 'rgba(39, 50, 70, 0.9)',
                color: SV_DARK.accentHover,
            },
        },
        '&.secondary:hover': {
            '.lightTheme &': {
                backgroundColor: 'rgba(218, 227, 246, 0.92)',
                color: SV_LIGHT.accentHover,
            },
            '.darkTheme &': {
                backgroundColor: 'rgba(46, 61, 89, 0.92)',
            },
        },
    },

}
